// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__ToolbarPluginForm__base","container":"cms__ToolbarPluginForm__container","rounded":"cms__ToolbarPluginForm__rounded","depth":"cms__ToolbarPluginForm__depth","clearfix":"cms__ToolbarPluginForm__clearfix","pluginForm":"cms__ToolbarPluginForm__pluginForm","header":"cms__ToolbarPluginForm__header","body":"cms__ToolbarPluginForm__body","footer":"cms__ToolbarPluginForm__footer"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/Toolbar/ToolbarPluginForm.css
// module id = 588
// module chunks = 0